export const defaultValues = {
  name: '',
  triggerType: '',
  actionType: '',
  target: {
    page: '',
    frame: '',
  },
  url: '',
  text: '',
  visible: false,
  mandatory: false,
  mandatoryType: '',
};

export const triggerMenu = [
  {
    click: 'On click',
  },
  {
    hover: 'Hover',
  },
];

export const actionOnClickMenu = [
  {
    navigate: 'Navigate to',
  },
  {
    notes: 'Notes',
  },
  {
    'pop-up': 'Show popup',
  },
];

export const actionOnHoverMenu = [
  {
    'tool-tip': 'Show tooltip',
  },
];

export const mandatoryMenu = [
  {
    once: 'Only once',
  },
];
